export default class ZoomHandler {
  constructor(spinner) {
    this.spinner = spinner;
    this.scale = 1;
    this.sceneWidth = 1;
    this.sceneHeight = 1;
    this.contentWidth = 1;
    this.contentHeight = 1;
    this.zoomedWidth = 1;
    this.zoomedHeight = 1;
    this.zoomPointX = 0;
    this.zoomPointY = 0;
  }

  setSceneSize(width, height) {
    this.sceneWidth = width;
    this.sceneHeight = height;
  }

  setContentSize(width, height) {
    this.contentWidth = width;
    this.contentHeight = height;
  }

  get transformOriginCss() {
    return this.spinner.transformOriginCSS;
  }

  get aspectRatioCss() {
    return this.spinner.aspectRatioCSS || "auto";
  }

  horizontalCompensation = 0;
  verticalCompensation = 0;
  contentHorOffset = 0;
  contentVerOffset = 0;

  /**
   * @param {number} x
   * @param {number} y
   * @param {number} scale
   * @param {number} prevScale
   * @returns {{pointX: number, pointY: number}}
   */
  getZoomPoint(x, y, scale, prevScale) {
    this.contentHorOffset = (this.sceneWidth - this.contentWidth) / 2;
    this.contentVerOffset = (this.sceneHeight - this.contentHeight) / 2;
    x = x - this.contentHorOffset;
    y = y - this.contentVerOffset;

    const contentX = (x - this.zoomPointX) / prevScale;
    const contentY = (y - this.zoomPointY) / prevScale;

    const pointX = x - contentX * scale;
    const pointY = y - contentY * scale;

    return {
      pointX,
      pointY,
    };
  }

  setZoomPoint(pointX, pointY, scale) {
    this.scale = scale;

    const contentWidth = this.contentWidth;
    const contentHeight = this.contentHeight;
    const zoomedWidth = contentWidth * scale;
    const zoomedHeight = contentHeight * scale;

    // Clamp so image always fills the container, never shows empty space
    const minX = Math.min(0, contentWidth - zoomedWidth);
    const maxX = 0;
    const minY = Math.min(0, contentHeight - zoomedHeight);
    const maxY = 0;

    this.horizontalCompensation = (zoomedWidth - contentWidth) / 2;
    this.verticalCompensation = (zoomedHeight - contentHeight) / 2;

    this.zoomedWidth = zoomedWidth;
    this.zoomedHeight = zoomedHeight;
    this.zoomPointX = Math.max(
      minX,
      Math.min(pointX ?? this.zoomPointX ?? 0, maxX),
    );
    this.zoomPointY = Math.max(
      minY,
      Math.min(pointY ?? this.zoomPointY ?? 0, maxY),
    );
  }

  getAsCss() {
    return {
      transformOrigin: this.transformOriginCss,
      aspectRatio: this.aspectRatioCss,
      width: `${this.zoomedWidth}px`,
      height: `${this.zoomedHeight}px`,
      translate: `${this.zoomPointX + this.horizontalCompensation}px ${this.zoomPointY + this.verticalCompensation}px`,
    };
  }
  getValues() {
    return {
      width: this.zoomedWidth,
      height: this.zoomedHeight,
      x: this.zoomPointX,
      y: this.zoomPointY,
    };
  }
}
